import { defineComponent as _defineComponent } from 'vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryInfoBlocks',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const { getAssetUrl } = useMediaAsset();

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

return { __sfc: true,isDesktop, getAssetUrl, swiperOptions, Swiper, SwiperSlide }
}

})